export default "__VITE_ASSET__Bohoy5eD__"